// extracted by mini-css-extract-plugin
module.exports = {"privacy_container":"PrivacyPolicy_privacy_container__6nsjH","body_container":"PrivacyPolicy_body_container__B4FrX","title":"PrivacyPolicy_title__JpB23"};